import { Controller } from "@hotwired/stimulus"

// Controller for selecting and adding tickets to cart
export default class extends Controller {
  static targets = ["ticketType", "quantityInput", "addButton", "message"]

  static values = {
    addUrl: String,
    opportunityId: Number
  }

  connect() {
    console.log("Ticket Selector Controller connected")
    this.updateButtonState()
  }

  ticketTypeChanged() {
    console.log("Ticket type changed:", this.ticketTypeTarget.value)
    this.updateButtonState()
    this.hideMessage()
  }

  quantityChanged() {
    console.log("Quantity changed:", this.quantityInputTarget.value)
    this.updateButtonState()
  }

  updateButtonState() {
    const ticketTypeId = this.ticketTypeTarget.value
    const quantity = parseInt(this.quantityInputTarget.value) || 0

    // Enable button only if ticket type is selected and quantity > 0
    const shouldEnable = ticketTypeId && quantity > 0
    this.addButtonTarget.disabled = !shouldEnable

    console.log("Button state updated:", { ticketTypeId, quantity, enabled: shouldEnable })
  }

  addToCart() {
    const ticketTypeId = this.ticketTypeTarget.value
    const quantity = parseInt(this.quantityInputTarget.value) || 1

    if (!ticketTypeId) {
      this.showMessage("Please select a ticket type", "warning")
      return
    }

    // Disable button while adding
    this.addButtonTarget.disabled = true
    this.addButtonTarget.innerHTML = '<i class="fas fa-spinner fa-spin me-2"></i>Adding...'

    fetch(this.addUrlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({
        ticket_type_id: ticketTypeId,
        quantity: quantity,
        opportunity_id: this.opportunityIdValue
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log("Add ticket response:", data)
      if (data.success) {
        this.showMessage("Ticket added to cart!", "success")

        // Reset form
        this.ticketTypeTarget.value = ""
        this.quantityInputTarget.value = 1

        // Dispatch event for cart to update
        document.dispatchEvent(new CustomEvent('cartUpdated', { detail: data }))

        // Reload page to show updated cart (or could use Turbo)
        if (data.redirect_url) {
          window.location.href = data.redirect_url
        } else {
          window.location.reload()
        }
      } else {
        this.showMessage(data.error || "Failed to add ticket", "danger")
      }
    })
    .catch(error => {
      console.error("Error adding ticket:", error)
      this.showMessage("An error occurred. Please try again.", "danger")
    })
    .finally(() => {
      this.addButtonTarget.disabled = false
      this.addButtonTarget.innerHTML = '<i class="fas fa-plus-circle me-2"></i>Add to Cart'
      this.updateButtonState()
    })
  }

  showMessage(text, type) {
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = text
      this.messageTarget.className = `alert alert-${type} mt-3`
      this.messageTarget.classList.remove('d-none')
    }
  }

  hideMessage() {
    if (this.hasMessageTarget) {
      this.messageTarget.classList.add('d-none')
    }
  }
}
